import { render, staticRenderFns } from "./AddArea.vue?vue&type=template&id=4496df13&scoped=true"
import script from "./AddArea.vue?vue&type=script&lang=js"
export * from "./AddArea.vue?vue&type=script&lang=js"
import style0 from "./AddArea.vue?vue&type=style&index=0&id=4496df13&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4496df13",
  null
  
)

export default component.exports